<template>
  <BaseNew @new-confirm-action="createEntry" @new-cancel-action="resetForm" @new-open-action="loadServerEntry"
    @clear-form-errors="clearFormErrors" ref="baseNew" width="70%" :formErrors="formErrors" :loading="loading"
    :pageLoading="pageLoading" :modelNameSingular="modelNameSingular" :inlineAddButton="inlineAddButton"
    :useModelInsteadOfButton="useModelInsteadOfButton">
    <template slot="newForm">
      <Form ref="form" :entry="entry" :extraData="extraData" :modelNameSingular="modelNameSingular" />
    </template>
  </BaseNew>
</template>

<script>
import gql from 'graphql-tag';
import Form from "./form.vue";
import BaseNew from "@shared_components/base_new.vue";

export default {
  data() {
    return {
      error: null,
      loading: true,
      pageLoading: false,
      formErrors: [],
      extraData: null,
    };
  },
  props: {
    entry: Object,
    useModelInsteadOfButton: {
      type: Boolean,
      default: false
    },
    inlineAddButton: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseNew: BaseNew
  },
  methods: {
    loadServerEntry: function () {
      this.error = null;
      this.loading = true;
      this.$apollo
        .query({
          query: LOAD_NEW_ENTRY_STORAGE_ADJUSTMENT_QUERY,
          fetchPolicy: "no-cache",
          variables: {
            movementItemId: this.entry.movementItemId,
          }
        })
        .then(response => {
          // this.entry = response.data.accountContext.entryStorageAdjustment;
          // console.log("entry", this.entry);
          // console.log("load", response.data.accountContext.entryStorageAdjustment);
          this.entry.validations = response.data.accountContext.entryStorageAdjustment.validations;
          this.extraData = response.data;

          this.entry.isStockEntryType = true;
          this.entry.entryMovementItemLotsAttributes = [];

          var res = this.extraData.accountContext.allStockAdjustmentReasons.find((item) => item.name == 'Ajuste de Colheita');
          // console.log('res', res);
          this.entry.stockAdjustmentReason = res;
          this.entry.stockAdjustmentReasonId = res.id;
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));

    },
    createServerEntry: function (field) {
      // console.log("val", this.entry.validations);
      // console.log("STOCK_ADJUSTMENT", field, this.entry.validations, this.deepFilterEntryWithAllowedFieldsForMutation(field, this.entry.validations));
      this.entry.adjustmentTypeText = 'Entrada';

      // this.$emit("entry-created", this.entry);
      this.pageLoading = true;
      // // console.log("entry adjustment entry", field);
      this.$apollo
        .mutate({
          mutation: CREATE_ENTRY_STORAGE_ADJUSTMENT,
          variables: {
            input: this.deepFilterEntryWithAllowedFieldsForMutation(field, this.entry.validations)
            // input: this.entry,
          }
        })
        .then(response => {
          // console.log("adj", response.data.createEntryStorageAdjustment);
          var errors = response.data.createEntryStorageAdjustment.errors

          if (errors.length) {
            this.formErrors = errors
          } else {
            this.entry.id = response.data.createEntryStorageAdjustment.stockAdjustment.id;
            this.entry.adjustmentTypeText = "Entrada";
            this.entry.storage = this.extraData.accountContext.allStorages.filter(storage=> storage.id == this.entry.storageId)[0];
            this.entry.exitMovementItemsAttributes = [];
            this.$refs.baseNew.closeDialog();
            this.$emit("entry-created", this.entry);
          }
        })
        .catch(error => {
          let { graphQLErrors, networkError, response, operation } = error;
          console.log("error", error)
          console.log("caiu no catch");
          console.log(graphQLErrors);
          console.log(networkError);
          console.log(response);
          console.log(operation);
          if (networkError) {
            console.log(`[Network error]: ${networkError}`);
          }
          else if (graphQLErrors) {
            graphQLErrors.map(({ message, locations, path }) =>
              console.log(
                `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`
              )
            );
          }
        })
        .finally(() => (this.pageLoading = false));
    },
    createEntry: function () {
      if (this.$refs.form.isFormValid()) {
        this.createServerEntry(this.entry);
        this.resetForm();
      }
    },
    resetForm: function () {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function () {
      this.formErrors = [];
    }
  }
};

const LOAD_NEW_ENTRY_STORAGE_ADJUSTMENT_QUERY = gql`
  query($movementItemId: ID){
    accountContext {
      entryStorageAdjustment {
        id
        code
        date
        description
        isStockEntryType
        storageId
        entryMovementItemsAttributes {
          id
          enabledLots
          entryMovementItemLotsAttributes{
            id
            itemLotAttributes{
              id
              name
            }
          }
        }
        stockAdjustmentReasonId
        validations
      }
      allStorages {
        id
        name
        location
      }
      allStockAdjustmentReasons {
        id
        name
      }    

      allCropsForAdjustment(movementItemId: $movementItemId)
    }
  }
`;

const CREATE_ENTRY_STORAGE_ADJUSTMENT = gql`
  mutation($input: EntryStorageAdjustmentCreateInputObject!) {
    createEntryStorageAdjustment(input: $input) {
      stockAdjustment {
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>
